export enum ConfirmationStatus {
    deny = 'DENY',
    backupDenied = 'BACKUP_DENIED',
}
